import {clone} from '~/utils/helpers'

export const contractGroupGetToPutTransformer = contractGroup => {
    const {$conf} = useNuxtApp()
    const rq = clone(contractGroup)

    rq.generalVatPlanId = rq.generalVatPlan?.id
    delete rq.generalVatPlan

    rq.commissionVatPlanId = rq.commissionVatPlan?.id
    delete rq.commissionVatPlan

    delete rq.contractGroupType

    const mappedProductKeys = getMappedProductKeys($conf.public.activeProducts, authStore.availableProducts)
    rq.fines = sortByMappedProductKeys(rq.fines, mappedProductKeys)
    rq.daySales = sortByMappedProductKeys(rq.daySales, mappedProductKeys)
    rq.groupingProducts = sortByMappedProductKeys(rq.groupingProducts, mappedProductKeys)

    const productTypeEnabled = {}
    mappedProductKeys.forEach(key => {
        productTypeEnabled[key] = rq.productTypeEnabled[key]
    })
    rq.productTypeEnabled = productTypeEnabled

    return rq
}

export const contractGroupSaveTransformer = contractGroup => {
    contractGroup.pricingRuleRoot = removeContractGroupProperties([contractGroup.pricingRuleRoot])[0]
    contractGroup.serviceFeeRuleRoot = removeContractGroupProperties([contractGroup.serviceFeeRuleRoot])[0]

    return contractGroup
}

export const removeContractGroupProperties = (entries, additionalProps = []) => {
    return entries.map(entry => {
        // eslint-disable-next-line no-unused-vars
        const {parentFilters, label, id, ...rest} = entry
        if (additionalProps.length) additionalProps.forEach(prop => delete rest[prop])
        if (rest.pricingRuleEntries?.length) {
            rest.pricingRuleEntries = removeContractGroupProperties(rest.pricingRuleEntries, additionalProps)
        }
        return rest
    })
}

export const companyContractGetToPutTransformer = contract => {
    delete contract.currencyChoice
    delete contract.singleCurrency
    delete contract.countriesCurrencies
    delete contract.currencies
    delete contract.contractGroup.contractGroupType
    delete contract.contractType

    if (contract.manager?.id) {
        contract.managerId = contract.manager?.id
        delete contract.manager
    }

    contract.contractGroup = contractGroupGetToPutTransformer(contract.contractGroup)
    return contract
}

export const getContractGroupFieldsMapper = (isShowCalculationCommission, isTAContract, isCorpContract) => ({
    products: ['productTypeEnabled'],
    calculation: [
        'currency',
        'pricingRuleRoot',
        'performSalesMode',
        'roundUpPrices',
        'roundUpCommission',
        isShowCalculationCommission && 'applyCommissionToCancelledService',
    ],
    service_fees: ['serviceFeeCurrency', 'serviceFeeRuleRoot'],
    vat: ['generalVatPlanId', 'commissionVatPlanId'],
    sales_terms: [
        'daySales',
        'showPackageRates',
        'voucherMode',
        'b2bPointOfSale',
        'b2cPointOfSale',
        runtimeStore.getCRMOption('asp.option.credit.limit.settings') && 'creditLimitSettings',
        'paymentMethodPlanId',
    ],
    cross_rates: ['charges'],
    cancellation_fees: ['fines'],
    invoices: [
        ...(runtimeStore.getCRMOption('asp.option.disable.invoice.module')
            ? ['manualInvoicesForFullAmount']
            : [
                  'enableRequestInvoicesForCustomer',
                  'enableRequestInvoicesForAllServices',
                  runtimeStore.getCRMOption('asp.option.invoice.partial') && 'enablePartialInvoiceForCustomer',
                  'enableEditVoucherAfterInvoicing',
                  runtimeStore.getCRMOption('asp.option.finance.event.rates.configuration.enabled') &&
                      'applyCustomRatesSettings',
                  runtimeStore.getCRMOption('asp.option.finance.event.rates.configuration.enabled') &&
                      'currentRateForFinanceEvent',
              ]),
    ],
    grouping: ['groupingProducts'],
    loyalty: [!isTAContract && 'loyalties'],
    tags: ['ignoreTagsSettingsForTO1', 'requestedTags', 'excludedTags'],
    additionally: [
        'enableUserModification',
        !isTAContract && !isCorpContract && 'enableAgencyModification',
        !isTAContract && !isCorpContract && 'allowToConfigureOwnPaymentMethods',
        !isTAContract &&
            runtimeStore.getCRMOption('asp.option.enable.customFields') &&
            'enableUserCustomFieldModification',
        runtimeStore.getCRMOption('asp.option.enable.business.trip.documents.generation') &&
            'enableBusinessTripDocumentsGeneration',
    ],
    agreementsWithSupplier: [],
    specialAgreements: [],
})

export const copyContractGroupEntries = async (contractGroupFieldsMapper, contractGroupTabs, contract) => {
    let contractGroup = {}
    contractGroupTabs.forEach(tab => {
        if (contractGroupFieldsMapper[tab]) {
            contractGroupFieldsMapper[tab].forEach(field => {
                if (field in contract) {
                    contractGroup[field] = contract[field]
                }
            })
        }
    })
    return contractGroup
}

export const sortByMappedProductKeys = (arr, order, key = 'productType') => {
    // Safety check: if arr is not an array, return empty array
    if (!Array.isArray(arr)) {
        return []
    }

    const orderMap = new Map()
    order.forEach((item, index) => {
        orderMap.set(item, index)
    })

    return [...arr].sort((a, b) => {
        const aValue = a[key]
        const bValue = b[key]

        if (orderMap.has(aValue) && orderMap.has(bValue)) {
            return orderMap.get(aValue) - orderMap.get(bValue)
        }
        if (orderMap.has(aValue)) return -1
        if (orderMap.has(bValue)) return 1

        return 0
    })
}
